// extracted by mini-css-extract-plugin
module.exports = {"burger_btn":"BurgerMenuButton_burger_btn__XsKbc","burger_svg":"BurgerMenuButton_burger_svg__NqA8F"};